module.exports = __webpack_public_path__ + "static/media/paypal.fbeb2086.svg";